import actionTypes from './actionTypes';
import {
  CreateChecklistAction,
  CreateChecklistSuccessAction,
  CreateChecklistErrorAction,
  UpdateChecklistAction,
  UpdateChecklistSuccessAction,
  UpdateChecklistErrorAction,
  LoadChecklistAction,
  LoadChecklistSuccessAction,
  LoadChecklistErrorAction,
  LoadFormDataAction,
  LoadFormDataSuccessAction,
  LoadFormDataErrorAction,
  LoadPositionsAction,
  LoadPositionsSuccessAction,
  LoadPositionsErrorAction,
  LoadUnitsAction,
  LoadUnitsSuccessAction,
  LoadUnitsErrorAction,
  ValidateUnitsAction,
  ValidateUnitsSuccessAction,
  LoadChecklistsAction,
  LoadChecklistsSuccessAction,
  LoadChecklistsErrorAction,
  DeleteChecklistAction,
  DeleteChecklistSuccessAction,
  DeleteChecklistErrorAction,
} from './actions.d';
import {
  ChecklistRecord,
  OptionRecord,
  PredefinedTaskRecord,
  ILoadChecklistsPayload,
  ILoadChecklistsSuccessPayload,
  ILoadUnitsPayload,
  IValidateUnitsPayload,
} from './types';
import { ChecklistFormState, UpdateChecklistFormState } from './editor/types';

const actions = {
  loadChecklists: (payload: ILoadChecklistsPayload): LoadChecklistsAction => ({
    type: actionTypes.LOAD_CHECKLISTS,
    payload,
  }),
  loadChecklistsSuccess: (payload: ILoadChecklistsSuccessPayload): LoadChecklistsSuccessAction => ({
    type: actionTypes.LOAD_CHECKLISTS_SUCCESS,
    payload,
  }),
  loadChecklistsError: (): LoadChecklistsErrorAction => ({
    type: actionTypes.LOAD_CHECKLISTS_ERROR,
  }),
  createChecklist: (payload: ChecklistFormState): CreateChecklistAction => ({
    type: actionTypes.CREATE_CHECKLIST_REQUEST,
    payload,
  }),
  createChecklistSuccess: (payload: { checklist: ChecklistRecord }): CreateChecklistSuccessAction => ({
    type: actionTypes.CREATE_CHECKLIST_SUCCESS,
    payload,
  }),
  createChecklistError: (): CreateChecklistErrorAction => ({
    type: actionTypes.CREATE_CHECKLIST_ERROR,
  }),
  updateChecklist: (payload: UpdateChecklistFormState): UpdateChecklistAction => ({
    type: actionTypes.UPDATE_CHECKLIST_REQUEST,
    payload,
  }),
  updateChecklistSuccess: (payload: { checklist: ChecklistRecord }): UpdateChecklistSuccessAction => ({
    type: actionTypes.UPDATE_CHECKLIST_SUCCESS,
    payload,
  }),
  updateChecklistError: (): UpdateChecklistErrorAction => ({
    type: actionTypes.UPDATE_CHECKLIST_ERROR,
  }),
  loadChecklist: (id: string): LoadChecklistAction => ({
    type: actionTypes.LOAD_CHECKLIST_REQUEST,
    payload: { id },
  }),
  loadChecklistSuccess: (payload: { checklist: ChecklistRecord }): LoadChecklistSuccessAction => ({
    type: actionTypes.LOAD_CHECKLIST_SUCCESS,
    payload,
  }),
  loadChecklistError: (): LoadChecklistErrorAction => ({
    type: actionTypes.LOAD_CHECKLIST_ERROR,
  }),
  loadFormData: (): LoadFormDataAction => ({
    type: actionTypes.LOAD_FORM_DATA_REQUEST,
  }),
  loadFormDataSuccess: (payload: {
    legalEntities: OptionRecord[];
    predefinedTasks: PredefinedTaskRecord[];
  }): LoadFormDataSuccessAction => ({
    type: actionTypes.LOAD_FORM_DATA_SUCCESS,
    payload,
  }),
  loadFormDataError: (): LoadFormDataErrorAction => ({
    type: actionTypes.LOAD_FORM_DATA_ERROR,
  }),
  loadPositions: (): LoadPositionsAction => ({
    type: actionTypes.LOAD_POSITIONS_REQUEST,
  }),
  loadPositionsSuccess: (payload: { positions: OptionRecord[] }): LoadPositionsSuccessAction => ({
    type: actionTypes.LOAD_POSITIONS_SUCCESS,
    payload,
  }),
  loadPositionsError: (): LoadPositionsErrorAction => ({
    type: actionTypes.LOAD_POSITIONS_ERROR,
  }),
  deleteChecklist: (payload: { id: string }): DeleteChecklistAction => ({
    type: actionTypes.DELETE_CHECKLIST,
    payload,
  }),
  deleteChecklistSuccess: (): DeleteChecklistSuccessAction => ({
    type: actionTypes.DELETE_CHECKLIST_SUCCESS,
  }),
  deleteChecklistError: (): DeleteChecklistErrorAction => ({
    type: actionTypes.DELETE_CHECKLIST_ERROR,
  }),
  loadUnits: (payload?: ILoadUnitsPayload): LoadUnitsAction => ({
    type: actionTypes.LOAD_UNITS_REQUEST,
    payload,
  }),
  loadUnitsSuccess: (payload: { units: OptionRecord[] }): LoadUnitsSuccessAction => ({
    type: actionTypes.LOAD_UNITS_SUCCESS,
    payload,
  }),
  loadUnitsError: (): LoadUnitsErrorAction => ({
    type: actionTypes.LOAD_UNITS_ERROR,
  }),
  validateUnits: (payload: IValidateUnitsPayload): ValidateUnitsAction => ({
    type: actionTypes.VALIDATE_UNITS_REQUEST,
    payload,
  }),
  validateUnitsSuccess: (payload: { invalidIds: string[] }): ValidateUnitsSuccessAction => ({
    type: actionTypes.VALIDATE_UNITS_SUCCESS,
    payload,
  }),
};

export default actions;
